import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckBedOrLitterTrayAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-bed-or-litter-tray-slot',
    templateUrl: './check-bed-or-litter-tray-slot.component.html',
    styleUrl: './check-bed-or-litter-tray-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBedOrLitterTraySlotComponent implements SheetSlotComponentBase {

	@Input() action!: CheckBedOrLitterTrayAction;
	value = null;

	constructor() {
	}
}
